import { createInstance } from '@module-federation/runtime';

const mf = createInstance({
  name: 'pco-product-service-frontend-view',
  remotes: [],
});

export async function loadModuleV2(
  name: string,
  url: string,
  componentName?: string,
  type: 'module' | 'var' = 'module',
) {
  mf.registerRemotes([
    {
      name,
      entry: url,
      type,
    },
  ]);

  const exposed = componentName?.replace(/^\.\//, '');
  await mf.loadRemote(exposed ? `${name}/${exposed}` : name);
}

export function getMSDRemoteBaseUrl() {
  const host = window.location.host;
  if (host.includes('sehlat.io')) {
    return 'https://modular-offering.iap-dev4.dias.sehlat.io/web/remoteEntry.js';
  } else if (host.includes('uat')) {
    return 'https://iap-fe-modularoffering-uat4.juliusbaer.com/web/remoteEntry.js';
  }
  return '';
}

export function getNestedRemoteBaseUrl() {
  const mergeRequestIid = import.meta.env.VITE_CI_MERGE_REQUEST_IID;

  if (mergeRequestIid !== undefined && mergeRequestIid !== null && mergeRequestIid.trim().length > 0) {
    return `https://pco-product-service-remote-pre-pco-product-service-${mergeRequestIid}.gcrm.sehlat.io`;
  }

  const host = window.location.host;
  // dev: nested remote always served at localhost:3001 regardless of which page (view@3000 or host@3002) is loading it
  if (host.startsWith('localhost:')) {
    return 'http://localhost:3001';
  }

  throw new Error(`No nested remote url found for host ${host} and mergeRequestIid ${mergeRequestIid}`);
}

export function getNestedRemoteUrl() {
  return `${getNestedRemoteBaseUrl()}/remoteEntry.js`;
}
